// extracted by mini-css-extract-plugin
module.exports = {"blue300":"#14267B","textContainer":"TextFields_textContainer__7WqSZ","markdown":"TextFields_markdown__f3e2Z","image":"TextFields_image__FL8iH"};